import React, { useState } from "react";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import moment from "moment"
import {
  Container,
  ListPatient,
  PatientSection,
  ImagePatient,
  NamePatient,
  ButtoAddPatient,
  ImgButtonAddPatient,
  ButtonBack,
  LabelBack,
  IconBack,
  DivType,
  Icon,
  DivArrow,
  Division,
  Title,
  SubTitle,
  ContainerPatient
} from "./styles";

import {
  GiBrain,
} from "react-icons/gi";

import {
  FiVideo,
} from "react-icons/fi";

import { useSelector, useDispatch } from "react-redux"
import Modal from "../modal"
import {
  setPatient,
  setSelectedPatient,
} from "../../redux/actions/patient.actions"

import { slotByMonth, slotByPatient, setOldSlot} from "../../redux/actions/schedule.actions"

import {
  setScheduleType,
} from "../../redux/actions/schedule.actions"
import {
  setSelectedProgram,
} from "../../redux/actions/telepsico.actions"

import { push } from "../../services/navigate"

export default function App(props) {
  const dispatch = useDispatch()

  const user = useSelector((state) => state.userReducer.user)
  const scheduleType = useSelector((state) => state.schedule.scheduleType)
  const [hiddenArrow, setHiddenArrow] = useState(true);

  const dependentsProps = useSelector(
    (state) => state.dependentsReducer.dependents
  )

  const scheduleInitial = {
    date: moment().format("YYYY-MM-DD").toString(),
    user: user,
  }

  let provider = localStorage.getItem("@selected_provider")

  provider = JSON.parse(provider)

  function _setScheduleType(type) {
    dispatch(setScheduleType(type))
  }

  function goToDependents() {
    props.onClose();
    push("/dependentes");
  }

  function _setPatient(patient) {
    dispatch(setPatient(patient));
    dispatch(setSelectedPatient(true));
    dispatch(setSelectedProgram(false));
    props.onClose();
    if(scheduleType == "TELEMEDICINA") {
      // dispatch(slotByPatient(user));
    }
    dispatch(setOldSlot(false));
    return push('/agendamento');
  }

  function getScrollPosition(el) {
    setHiddenArrow(false);
    const elemento = el.target;
    if (elemento.scrollHeight - elemento.scrollTop === elemento.clientHeight) {
      setHiddenArrow(true);
    }
  }

  function cutName(fisrtName, lastName) {
    let fullName = `${fisrtName} ${lastName}`

    // if (fullName && fullName.length > 15) {
    //   return fisrtName;
    // }
    return fullName
  }

  return (
    <Modal isOpen={props.isOpen} onClose={props.onClose}>
      {scheduleType ?
        <ContainerPatient>
          <ButtonBack
            type="button"
            onClick={() => props.onClose()}
          >
            <IconBack src="img/icons/back-icon.png"></IconBack>
            <LabelBack>Voltar</LabelBack>
          </ButtonBack>
          <h3>Selecione para quem é o atendimento</h3>
          <ListPatient onScroll={getScrollPosition}>
            <PatientSection onClick={() => _setPatient(user)}>
              <ImagePatient
                src={user.image || "img/default.png"}
              />
              <NamePatient>{`${cutName(user.name, user.lastName)}`}</NamePatient>
            </PatientSection>

            {(dependentsProps || []).map((patientItem) => (
              <PatientSection onClick={() => _setPatient(patientItem)}>
                <ImagePatient
                  src={
                    (patientItem.signUpDocuments &&
                      patientItem.signUpDocuments.image) ||
                    "img/default.png"
                  }
                  onError={(e) => e.target.src = "img/default.png"}
                />
                <NamePatient>{`${cutName(
                  patientItem.firstName,
                  patientItem.lastName
                )}`}</NamePatient>
              </PatientSection>
            ))}

            <PatientSection onClick={() => goToDependents()}>
              <ButtoAddPatient>
                <ImgButtonAddPatient
                  src="img/icons/addDependent.svg"
                />
              </ButtoAddPatient>
              <NamePatient>Adicionar</NamePatient>
            </PatientSection>
          </ListPatient>
          {!hiddenArrow && (
            <DivArrow>
              <ArrowDownwardIcon />
            </DivArrow>
          )}
        </ContainerPatient>
        :
        <Container>
          <ButtonBack
            type="button"
            onClick={() => props.onClose()}
          >
            <IconBack src="img/icons/back-icon.png"></IconBack>
            <LabelBack>Voltar</LabelBack>
          </ButtonBack>
          <Title>Selecione a especialidade</Title>
          <DivType onClick={() => _setScheduleType("TELEMEDICINA")}>
            <Icon>
              <FiVideo />
            </Icon>
            <SubTitle>Agendamento Telemedicina</SubTitle>
          </DivType>
          <Division />
          <DivType onClick={() => _setScheduleType("TELEPSICOLOGIA")}>
            <Icon>
              <GiBrain />
            </Icon>
            <SubTitle>Agendamento Telepsicologia</SubTitle>
          </DivType>
        </Container>
      }
    </Modal >
  );
}
